import { render, staticRenderFns } from "./Cardresapast.vue?vue&type=template&id=75e73476&"
import script from "./Cardresapast.vue?vue&type=script&lang=js&"
export * from "./Cardresapast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports